<template>
  <RouterView v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </transition>
  </RouterView>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';

import { useBuergenStore } from '@/shared/Buergen/useBuergenStore';
import { Buerge } from '@/shared/Buergen/types';
import { getNutzer } from './service/TokenService';
import partnerserviceApi from './connection/partnerservice-api';
import {
  createEmptyLänderStorage as createEmptyLaenderStorage,
  speichereLänderStorage as speichereLaenderStorage,
} from './persistence/LänderStorage';
import {
  createEmptyNavigationStorage,
  speichereNavigationStorage,
} from './persistence/NavigationStorage';
import { createEmptyRechteStorage, speichereRechteStorage } from './persistence/RechteStorage';

defineOptions({
  name: 'App',
});

const ladeLaender = async () => {
  const partnerResponse = await partnerserviceApi.findeLänderliste();
  const laenderStorage = createEmptyLaenderStorage();
  laenderStorage.länder = partnerResponse.data;
  speichereLaenderStorage(laenderStorage);
};

const ladeRollen = async () => {
  const partnerResponseEigene = await partnerserviceApi.holeEigeneRechte();
  const rechteStorage = createEmptyRechteStorage();
  rechteStorage.eigeneRechte = partnerResponseEigene.data;
  speichereRechteStorage(rechteStorage);
};

const ladeBuergenMap = async () => {
  const partnerResponse = await partnerserviceApi.findeAlleBürgen();
  const buergen: Buerge[] = partnerResponse.data;
  const buergenStore = useBuergenStore();

  buergen.forEach((b) => buergenStore.fuegeBuergeHinzu(b));
};

const setNutzer = async () => {
  const nutzer = getNutzer();
  const navigationStorage = createEmptyNavigationStorage();
  navigationStorage.nutzer = nutzer;
  navigationStorage.vollerName = `${nutzer.vorname} ${nutzer.nachname}`;
  speichereNavigationStorage(navigationStorage);
};

/**
 * Daten zum Nutzer abwarten, da
 * 1. wichtig für Namensanzeige und
 * 2. keine Probleme erwartet werden, da Keycloak ja erreichbar sein muss
 * (wir haben uns ja gerade eingeloggt).
 */
setNutzer().then(() => {
  // Nicht essenzielle Daten werden nachgelagert geladen und nicht abgewartet
  ladeRollen();
  /**
   * Die Länder ohne direkten Bedarf vorweg zu laden ist unnötig. Sie sollten bei der ersten
   * Anfrage geholt und dann gecacht werden (idealerweise auch einfach über den Browser-Cache,
   * wie Cache-Header, den das Backend setzt)
   */
  ladeLaender();
  ladeBuergenMap();
});
</script>

<style>
/** Fade Transitions */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
